module.exports = __webpack_public_path__ + "img/hub.6ff97545.svg";